import { useGetDatasetMapperData } from "api/api-hooks/dataset-mapper-hooks";

// eslint-disable-next-line import/prefer-default-export
export const useDatasetMappedValue = (mapValue: number | undefined, mapperId: number) => {
  const { data, isLoading } = useGetDatasetMapperData(mapperId);

  if (isLoading) return null;
  if (mapValue === undefined) return "N/A";
  if (!data || !data.mappings) return mapValue;
  return data.mappings[mapValue];
};
